import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import { Link } from 'react-router-dom';

import routes from 'app/routes';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Managers/Coaches/Context';
import Invite from 'components/Managers/Coaches/Pages/Invite/Index';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import NoData from './NoData';
import columns from './columns';

import EditCoach from '../Edit/Index';

export default function Index() {
  const { actions, dispatch, state } = useContext();
  const [invitedList, setInvitedList] = useState([]);
  const [editCoach, setEditCoach] = useState(null);

  const selectCoachesToInvite = (ids) => {
    const coachesForInvite = (state.coaches || []).filter((item) => ids.includes(item.id));
    setInvitedList(coachesForInvite);
  };

  const onActivate = (row) => {
    confirmAlert({
      title: 'Activate Coach',
      text: 'Are you sure you want to activate coach?',
      confirmButtonText: 'Activate',
    }, () => {
      actions.activate(dispatch, row.id);
    });
  };

  const onBlock = (row) => {
    confirmAlert({
      title: 'Block Coach',
      text: 'Are you sure you want to block coach?',
      confirmButtonText: 'Block',
    }, () => {
      actions.block(dispatch, row.id);
    });
  };

  const rowActions = [
    {
      type: 'EXPAND',
    },
    {
      title: 'Invite',
      type: 'CUSTOM',
      iconClass: 'invite-icon',
      onClick: (row) => { selectCoachesToInvite([row.id]); },
    },
    {
      title: 'Edit',
      type: 'CUSTOM',
      iconClass: 'edit-icon',
      onClick: (row) => { setEditCoach(row); },
    },
    {
      title: 'Block',
      type: 'CUSTOM',
      iconClass: 'cancel',
      showCondition: (row) => row.attributes.status === 'active',
      onClick: (row) => { onBlock(row); },
    },
    {
      title: 'Activate',
      type: 'CUSTOM',
      iconClass: 'checkmark-icon',
      showCondition: (row) => row.attributes.status !== 'active',
      onClick: (row) => { onActivate(row); },
    },
  ];

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <div className="content">
      <section>
        <Row>
          <Col>
            <h1>Internal Coach Pool</h1>
          </Col>

          <Col xs="auto">
            <Link
              to={routes.managers.coaches.add}
              className="btn btn-primary my-2 my-md-0"
            >
              Add New Coaches
            </Link>
          </Col>
        </Row>
      </section>

      <section className="pt-2">
        <Table
          title=" "
          columns={columns}
          data={state.coaches || []}
          loading={state.coaches === null}
          rowActions={rowActions}
          selectableRows={false}
          noData={<NoData />}
        />
      </section>

      {invitedList.length > 0 && (
      <Invite
        coaches={invitedList}
        cancelCallback={() => setInvitedList([])}
        sentCallback={() => setInvitedList([])}
      />
      )}

      {editCoach && (
      <EditCoach
        coach={editCoach}
        closeEditCoach={() => setEditCoach(null)}
      />
      )}

    </div>
  );
}
